



























import { Component, Vue, Prop } from "vue-property-decorator";
import { ListItemDTO, PubIssueDTO } from "../../../Generated/ParticaAPI";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";


@Component({
	name: "IssuesList",
	components: {}
})
export default class IssuesList extends Vue {
	@Prop() private issues: PubIssueDTO[];
	private search: string = "";

	private headers: any[] = [
		{ text: "Live", value: "live", sortable: true },
		{ text: "Status", value: "issueStatus", sortable: true },
		{
			text: "Name",
			align: "left",
			sortable: true,
			value: "name"
		},
		{ text: "Date", value: "issueDate", sortable: true },
	];


	private getStatusColor(issue: PubIssueDTO): string {
		switch (issue.issueStatus) {
			case 1: { // processed
				return "green";
				break;
			}
			case 0: { // processing
				return "blue";
				break;
			}
			case 2: {
				return "red"; // error
				break;
			}
			default: {
				return "Unknown";
			}

		}
	}
	private getStatus(issue: PubIssueDTO): string {
		switch (issue.issueStatus) {
			case 1: { // processed
				return "Processed";
				break;
			}
			case 0: { // processing
				return "Processing";
				break;
			}
			case 2: {
				return "Error"; // error
				break;
			}
			default: {
				return "Unknown";
			}
		}
	}


	private getLiveColor(issue: PubIssueDTO): string {
		if (issue.live === 0) {
			return "orange";
		}
		return "green";
	}

	private selectIssue(issue: PubIssueDTO) {
		this.$emit("partica-event", { action: eParticaAction.ISSUE_SELECT, item: issue } as ParticaEvent);
	}
	private rightClick(issue: PubIssueDTO) {
		this.$emit("partica-event", { action: eParticaAction.RIGHT_MOUSE_CLICK, item: issue } as ParticaEvent);
	}
}
